module.exports = __webpack_public_path__ + "static/media/downarrow.99b516f4.svg";